import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { Scroll } from '../programInformation/scroll/scroll.component';
import { PodcastInformationTop } from './top/podcastInformationTop.component';
import { PodcastDescription } from './description/podcastDescription.component';
import { defaultContext, getContainerHeight, getInitialStyle, TEXT_WIDTH } from './podcastInformation.style';
import { PROGRAM_INFORMATION_CLOSED_SIGNAL } from './podcastInformation.constants';

export class PodcastInformation extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Overlay: {
          rect: true,
        },
        ContentContainer: {
          Top: {
            type: PodcastInformationTop,
          },
          Scroll: {
            type: Scroll,
            content: {
              type: PodcastDescription,
              w: TEXT_WIDTH[defaultContext.screenSize],
            },
          },
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  set data(content) {
    if (!content) {
      return;
    }

    const top = this.tag('Top');
    const scroll = this.tag('Scroll');
    const { screenSize } = this._style;
    const scrollableView = scroll.content;

    if (scrollableView) {
      top.once('txLoaded', () => {
        scroll.y = top.h;
        scroll.h = getContainerHeight(screenSize) - scroll.y;
        scrollableView.data = content;
      });
    }

    top.data = content;
  }

  _getFocused() {
    return this.tag('Scroll');
  }

  _handleKey() {
    return true;
  }

  _handleBack() {
    this.signal(PROGRAM_INFORMATION_CLOSED_SIGNAL);

    return true;
  }

  _handleEnter() {
    if (this.tag('ExitButton').visible) {
      this.signal(PROGRAM_INFORMATION_CLOSED_SIGNAL);
    }

    return true;
  }
}
